import React, { useState } from 'react';
import { Phone, PlusCircle, Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'HOME',
    href: '/'
  }, {
    name: 'ABOUT US',
    href: '/about'
  }, {
    name: 'SERVICES',
    href: '/services'
  }, {
    name: 'APPOINTMENT REQUEST',
    href: '/appointment'
  }, {
    name: 'CONTACT US',
    href: '/contact'
  }];
  return <header className="w-full flex flex-col font-sans" data-id="element-73">
      {/* Top Utility Bar */}
      <div className="bg-slate-900 text-slate-300 py-2 px-4 text-sm" data-id="element-74">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-end items-center gap-4 sm:gap-6" data-id="element-75">
          <Link to="/appointment" className="flex items-center gap-1.5 hover:text-white transition-colors font-medium" data-id="element-76">
            <PlusCircle className="w-4 h-4 text-[#b87333]" data-id="element-77" />
            REQUEST AN ESTIMATE
          </Link>
          <a href="tel:7146023634" className="flex items-center gap-1.5 hover:text-white transition-colors font-medium" data-id="element-78">
            <Phone className="w-4 h-4 text-[#b87333]" data-id="element-79" />
            (714) 602-3634
          </a>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-[#0c2340] text-white shadow-md sticky top-0 z-50" data-id="element-80">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:py-6 flex justify-between items-center" data-id="element-81">
          {/* Logo Area */}
          <Link to="/" className="flex items-center" data-id="element-82">
            <img src="https://cdn.magicpatterns.com/uploads/qa84VP1fEhJxAxqz3KkeSm/logo.png" alt="A-Flow Seamless Rain Gutters" className="h-10 sm:h-12 w-auto brightness-0 invert" data-id="element-83" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-84">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href || location.pathname === '/' && link.href === '/';
            return <Link key={link.name} to={link.href} className={`text-sm font-semibold tracking-wide transition-colors py-2 border-b-2 ${isActive ? 'text-white border-[#b87333]' : 'text-slate-300 border-transparent hover:text-white hover:border-slate-500'}`} data-id="element-85">
                  {link.name}
                </Link>;
          })}
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-86">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-87" /> : <Menu className="w-6 h-6" data-id="element-88" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && <nav className="lg:hidden bg-[#0a1c33] border-t border-slate-700" data-id="element-89">
            <ul className="flex flex-col px-4 py-2" data-id="element-90">
              {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <li key={link.name} data-id="element-91">
                    <Link to={link.href} onClick={() => setIsMobileMenuOpen(false)} className={`block py-3 text-sm font-semibold tracking-wide ${isActive ? 'text-[#b87333]' : 'text-slate-300'}`} data-id="element-92">
                      {link.name}
                    </Link>
                  </li>;
          })}
            </ul>
          </nav>}
      </div>
    </header>;
}